import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { callbacks, getAdapter } from '../../config/api';
import enums from '../../constants/enums';
import Addresses from './Addresses';
import PhoneNumbers from './PhoneNumbers';
import EmailAddresses from './EmailAddresses';
var ContactInformation = /*#__PURE__*/function (_Component) {
  _inherits(ContactInformation, _Component);
  var _super = _createSuper(ContactInformation);
  function ContactInformation(props) {
    var _this;
    _classCallCheck(this, ContactInformation);
    _this = _super.call(this, props);
    _this.deleteAddress = _this.deleteAddress.bind(_assertThisInitialized(_this));
    _this.onSaveEmails = _this.onSaveEmails.bind(_assertThisInitialized(_this));
    _this.onSavePhones = _this.onSavePhones.bind(_assertThisInitialized(_this));
    _this.updateOrCreateAddress = _this.updateOrCreateAddress.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ContactInformation, [{
    key: "onSavePhones",
    value: function onSavePhones() {
      var phoneNumbers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var contact = this.props.contact;
      var contactId = get(contact, 'id');
      return getAdapter('coreApi').updateRecord("person", contactId, {
        phone_numbers: phoneNumbers
      }).then(function () {
        callbacks.onClientSaved({
          message: 'Phone Number Successfully Updated.'
        });
      }).catch(function (error) {
        var _context;
        var errors = _mapInstanceProperty(_context = error.response.data.errors).call(_context, function (e) {
          return e.title;
        });
        var duplicatePhoneMsg = 'phone_numbers cannot be duplicate';
        if (_includesInstanceProperty(errors).call(errors, duplicatePhoneMsg)) {
          throw new Error(duplicatePhoneMsg);
        }
        throw error;
      });
    }
  }, {
    key: "onSaveEmails",
    value: function onSaveEmails() {
      var emailAddresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var contact = this.props.contact;
      var contactId = get(contact, 'id');
      return getAdapter('coreApi').updateRecord("person", contactId, {
        email_addresses: emailAddresses
      }).then(function () {
        callbacks.onClientSaved({
          message: 'Email Address Successfully Updated'
        });
      });
    }
  }, {
    key: "deleteAddress",
    value: function deleteAddress(id) {
      return getAdapter('coreApi').deleteRecord('address', id).then(function () {
        callbacks.onClientSaved({
          message: 'Address Successfully Deleted'
        });
      });
    }
  }, {
    key: "updateOrCreateAddress",
    value: function () {
      var _updateOrCreateAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(addresses) {
        var _this$props$contact, contact, contactId;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props$contact = this.props.contact, contact = _this$props$contact === void 0 ? {} : _this$props$contact;
              contactId = get(contact, 'id', '');
              _context2.next = 4;
              return _Promise.all(_mapInstanceProperty(addresses).call(addresses, function (address) {
                if (address.id) {
                  return getAdapter('coreApi').updateRecord('address', address.id, address);
                }
                return getAdapter('coreApi').createRecord('address', _objectSpread(_objectSpread({}, address), {}, {
                  person: contactId
                }));
              })).then(function () {
                callbacks.onClientSaved();
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function updateOrCreateAddress(_x) {
        return _updateOrCreateAddress.apply(this, arguments);
      }
      return updateOrCreateAddress;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        contact = _this$props.contact,
        groupId = _this$props.groupId,
        shouldShowLastUpdate = _this$props.shouldShowLastUpdate,
        lastUpdate = _this$props.lastUpdate;
      var contactId = get(contact, 'id', '');
      var addressTypes = get(enums, 'contact_data.address_types', []);
      var phoneTypes = get(enums, 'contact_data.phone_types', []);
      return /*#__PURE__*/React.createElement("div", {
        className: "row contact-information mb-one"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/React.createElement("h3", null, "Contact Information"), /*#__PURE__*/React.createElement(PhoneNumbers, {
        groupId: groupId,
        onSave: this.onSavePhones,
        phoneNumbers: get(contact, 'phone_numbers', []),
        phoneTypes: phoneTypes,
        lastUpdate: lastUpdate.phoneNumbers,
        shouldShowLastUpdate: shouldShowLastUpdate
      }), /*#__PURE__*/React.createElement(Addresses, {
        addresses: get(contact, 'addresses', []),
        addressTypes: addressTypes,
        contactId: contactId,
        deleteAddress: this.deleteAddress,
        groupId: groupId,
        rootObj: "contact",
        updateOrCreateAddress: this.updateOrCreateAddress,
        lastUpdate: lastUpdate.addresses,
        shouldShowLastUpdate: shouldShowLastUpdate
      }), /*#__PURE__*/React.createElement(EmailAddresses, {
        contactId: contactId,
        emails: get(contact, 'email_addresses', []),
        groupId: groupId,
        onSave: this.onSaveEmails,
        rootObj: "contact"
      })));
    }
  }]);
  return ContactInformation;
}(Component);
ContactInformation.propTypes = {
  contact: PropTypes.shape({
    addresses: PropTypes.array.isRequired,
    email_addresses: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    phone_numbers: PropTypes.array.isRequired
  }).isRequired,
  lastUpdate: PropTypes.object,
  shouldShowLastUpdate: PropTypes.bool
};
ContactInformation.defaultProps = {
  lastUpdate: {
    recently_updated_by_name: null,
    recently_updated_at: null
  },
  shouldShowLastUpdate: false
};
export default ContactInformation;
//# sourceMappingURL=index.js.map